import script from "./Step.vue?vue&type=script&setup=true&lang=ts"
export * from "./Step.vue?vue&type=script&setup=true&lang=ts"

import "./Step.vue?vue&type=style&index=0&id=6604e292&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6604e292"]])

export default __exports__